// stores/commonStore.ts
import { createZustandStore } from '~/stores/store';

type CommonData = Record<string, any>;

type CommonStore = {
  data: CommonData;
  setData: (key: string, value: any) => void;
};

export const [commonStore, useCommonStore, createCommonHook] =
  createZustandStore<CommonStore>((set) => ({
    data: {},
    setData: (key, value) =>
      set((state) => ({
        data: { ...state.data, [key]: value },
      })),
  }));